package dev.mft.website.composable.footer

import androidx.window.core.layout.WindowHeightSizeClass
import androidx.window.core.layout.WindowWidthSizeClass

data class FooterLayoutConfig(
    val skillFontSize: Float,
    val skillImageSize: Float,
    val contactFontSize: Float,
    val contactImageSize: Float
) {
    companion object {
        fun getLayoutConfig(
            widthClass: WindowWidthSizeClass,
            heightClass: WindowHeightSizeClass
        ): FooterLayoutConfig {
            return when (widthClass) {
                // SMARTPHONE
                WindowWidthSizeClass.COMPACT -> when (heightClass) {
                    WindowHeightSizeClass.COMPACT -> FooterLayoutConfig(
                        skillFontSize = 0.06f,
                        skillImageSize = 0.08f,
                        contactFontSize = 0.04f,
                        contactImageSize = 0.12f
                    )
                    WindowHeightSizeClass.MEDIUM -> FooterLayoutConfig(
                        skillFontSize = 0.065f,
                        skillImageSize = 0.10f,
                        contactFontSize = 0.05f,
                        contactImageSize = 0.15f
                    )
                    else -> FooterLayoutConfig(
                        skillFontSize = 0.09f,
                        skillImageSize = 0.11f,
                        contactFontSize = 0.055f,
                        contactImageSize = 0.15f
                    )
                }

                // TABLET
                WindowWidthSizeClass.MEDIUM -> when (heightClass) {
                    WindowHeightSizeClass.COMPACT -> FooterLayoutConfig(
                        skillFontSize = 0.05f,
                        skillImageSize = 0.10f,
                        contactFontSize = 0.045f,
                        contactImageSize = 0.13f
                    )
                    WindowHeightSizeClass.MEDIUM -> FooterLayoutConfig(
                        skillFontSize = 0.06f,
                        skillImageSize = 0.13f,
                        contactFontSize = 0.055f,
                        contactImageSize = 0.15f
                    )
                    else -> FooterLayoutConfig(
                        skillFontSize = 0.065f,
                        skillImageSize = 0.15f,
                        contactFontSize = 0.06f,
                        contactImageSize = 0.15f
                    )
                }
                
                // PC/DESKTOP
                else -> when (heightClass) {
                    WindowHeightSizeClass.COMPACT -> FooterLayoutConfig(
                        skillFontSize = 0.06f,
                        skillImageSize = 0.10f,
                        contactFontSize = 0.06f,
                        contactImageSize = 0.13f
                    )
                    WindowHeightSizeClass.MEDIUM -> FooterLayoutConfig(
                        skillFontSize = 0.07f,
                        skillImageSize = 0.12f,
                        contactFontSize = 0.07f,
                        contactImageSize = 0.15f
                    )
                    else -> FooterLayoutConfig(
                        skillFontSize = 0.08f,
                        skillImageSize = 0.14f,
                        contactFontSize = 0.08f,
                        contactImageSize = 0.15f
                    )
                }
            }
        }
    }
}